import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Save, Loader2 } from "lucide-react";
import RouteFields from "@/components/RouteFields";

export default function RouteEditDialog({ open, onOpenChange, route, onSaved }) {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);
  const current = form || route;

  const save = async () => {
    if (!current.name) return toast.error("Nom de route requis");
    setSaving(true);
    try {
      const saved = (await api.put(`/routes/${route.id}`, current)).data;
      onSaved(saved?.legs ? saved : current);
      toast.success("Route enregistrée — log de nav mis à jour");
      setForm(null);
      onOpenChange(false);
    } catch {
      toast.error("Erreur d'enregistrement");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) setForm(null); onOpenChange(v); }}>
      <DialogContent data-testid="route-edit-dialog" aria-describedby={undefined}
        className="max-h-[90vh] max-w-4xl overflow-y-auto border-slate-700 bg-[#0B1222] text-slate-100">
        <DialogHeader>
          <DialogTitle className="font-display text-cyan-300">Modifier la route</DialogTitle>
        </DialogHeader>
        {current && (
          <div className="space-y-4">
            <RouteFields form={current} setForm={(fn) => setForm((f) => (typeof fn === "function" ? fn(f || route) : fn))} />
            <div className="flex justify-end gap-2">
              <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="route-edit-cancel"
                className="border-slate-700 bg-transparent text-slate-200 hover:bg-slate-800">Annuler</Button>
              <Button onClick={save} disabled={saving} data-testid="route-edit-save"
                className="bg-cyan-500 font-semibold text-[#070C18] hover:bg-cyan-400">
                {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Save className="mr-1.5 h-4 w-4" /> Enregistrer la route</>}
              </Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
